import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusCommission.tsx
const IconApplicationStatusCommission = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M2.083 5.833a3.333 3.333 0 1 0 6.666 0 3.333 3.333 0 0 0-6.666 0M1.666 17.5v-3.75a3.75 3.75 0 1 1 7.5 0v3.75zm12.917-8.333a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667m-3.75 8.333v-3.75a3.75 3.75 0 1 1 7.5 0v3.75z"
	})]
});
var IconApplicationStatusCommission_default = forwardRef(IconApplicationStatusCommission);
//#endregion
export { IconApplicationStatusCommission_default as default };
